import { Seo, Div } from 'ui';
import useResponsive from 'utils/hooks/useResponsive';

import Benefits from './Benefits';
import Earn from './Earn';
import Hero from './Hero';
import Steps from './Steps';
import AreYouReady from './AreYouReady';
import { useTranslation } from 'react-i18next';


const BeCreator = () => {

  const { isMobile } = useResponsive()
  const { t } = useTranslation()

  return (
    <Div as='section' backgroundColor='white'>

      <Seo
        title={t('seoBeCreatorTitle')}
        description={t('seoBeCreatorDescription')}
      />

      <Hero />

      <Div
        padding={isMobile ? '64px 0' : '120px 0'}
        background='linear-gradient(180deg, #FFFFFF 0%, #F5F9FC 100%)'
      >
        <Benefits />

        <Steps />

        <Div
          height={2}
          width='80%'
          maxWidth={970}
          margin={isMobile ? '64px auto 0' : '120px auto 0'}
          background='linear-gradient(270deg, rgba(244, 244, 245, 0) 0%, rgba(228, 228, 231, 0) 0.01%, #E4E4E7 50.43%, rgba(228, 228, 231, 0) 100%)'
        />

        <Earn />
      </Div>

      <AreYouReady />
    </Div>
  )
}

export default BeCreator
